import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { GET_DOCUMENTS } from '../../actions/docs';

const selectRoot = ({ additionalSettings }: RootState) => additionalSettings;

const selectRootLoader = ({ loaders }: RootState) => loaders;

export const selectGetAdditionalSettingsLoader = createSelector(
    selectRootLoader,
    loaders => loaders[GET_DOCUMENTS],
);

export const selectAdditionalSettings = createSelector(
    selectRoot,
    ({ additionalSettings }) => additionalSettings,
);
